import { defineComponent as h, computed as d, createBlock as l, openBlock as t, unref as a, mergeProps as g, createSlots as B, withCtx as i, createElementVNode as C, createElementBlock as b, createCommentVNode as m, renderSlot as f, Fragment as N, createVNode as u, resolveDynamicComponent as O } from "vue";
import E from "./highrise353.mjs";
import z from "./highrise395.mjs";
import H from "./highrise354.mjs";
import p from "./highrise355.mjs";
import F from "./highrise345.mjs";
import { JSONtoNaiveVars as I } from "./highrise297.mjs";
import L from "./highrise431.mjs";
import "./highrise34.mjs";
import "./highrise58.mjs";
import M from "./highrise433.mjs";
import { modalThemeOverrides as D, modalStyleOverrides as S } from "./highrise434.mjs";
import "./highrise27.mjs";
import { COMPONENT_NAME as A } from "./highrise174.mjs";
import T from "./highrise435.mjs";
import k from "./highrise81.mjs";
import V from "./highrise135.mjs";
import P from "./highrise121.mjs";
const R = { class: "hr-dialog__content--text" }, J = h({
  name: A.MODAL
}), ae = /* @__PURE__ */ h({
  ...J,
  props: {
    id: {},
    autoFocus: { type: Boolean, default: !1 },
    className: { default: void 0 },
    closeOnEsc: { type: Boolean, default: !0 },
    maskClosable: { type: Boolean, default: !0 },
    show: { type: Boolean, default: !1 },
    showBack: { type: Boolean, default: !1 },
    showClose: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showHeaderIcon: { type: Boolean, default: !0 },
    to: { default: void 0 },
    type: { default: "default" },
    width: { default: 483 },
    zIndex: { default: void 0 },
    footerDivider: { type: Boolean }
  },
  emits: ["after-enter", "after-leave", "back", "before-leave", "close", "esc", "left-click", "mask-click", "right-primary-click", "right-secondary-click", "update:show"],
  setup(v) {
    const r = v, c = {
      default: p,
      error: F,
      info: p,
      success: H,
      warning: E
    }, y = d(() => D(r)), w = d(() => I(S(r))), n = d(() => r.type), $ = d(() => ({
      "hr-modal": !0,
      "hr-modal--auto-focus": r.autoFocus,
      "hr-modal--close-on-esc": r.closeOnEsc,
      "hr-modal--mask-closable": r.maskClosable,
      "hr-modal--show-back": r.showBack,
      "hr-modal--show-close": r.showClose,
      "hr-modal--show-footer": r.showFooter,
      "hr-modal--show-header": r.showHeader,
      "hr-modal--show-header-icon": r.showHeaderIcon,
      [`hr-modal--${r.to}`]: r.to,
      [`hr-modal--${n.value}`]: n.value,
      className: r.className
    }));
    return (e, o) => (t(), l(a(T), g({
      preset: "dialog",
      "auto-focus": e.autoFocus,
      class: $.value,
      "close-on-esc": e.closeOnEsc,
      "mask-closable": e.maskClosable,
      show: e.show,
      style: w.value,
      "theme-overrides": y.value,
      to: e.to,
      "z-index": e.zIndex
    }, e.$attrs, {
      onAfterEnter: o[4] || (o[4] = () => e.$emit("after-enter")),
      onAfterLeave: o[5] || (o[5] = () => e.$emit("after-leave")),
      onBeforeLeave: o[6] || (o[6] = () => e.$emit("before-leave")),
      onClose: o[7] || (o[7] = () => e.$emit("close")),
      onEsc: o[8] || (o[8] = () => e.$emit("esc")),
      onMaskClick: o[9] || (o[9] = (s) => e.$emit("mask-click", s)),
      "onUpdate:show": o[10] || (o[10] = (s) => e.$emit("update:show", s))
    }), B({
      default: i(() => [
        C("div", R, [
          e.$slots.default ? (t(), l(a(k), {
            key: 0,
            size: "md",
            weight: "regular",
            class: "hr-modal__content"
          }, {
            default: i(() => [
              f(e.$slots, "default")
            ]),
            _: 3
          })) : m("", !0)
        ]),
        e.showFooter ? (t(), b(N, { key: 0 }, [
          e.footerDivider ? (t(), l(a(V), {
            key: 0,
            "title-placement": "right",
            "margin-bottom": !1,
            "margin-top": !1
          })) : m("", !0),
          e.$slots.footer ? f(e.$slots, "footer", { key: 1 }) : (t(), l(M, {
            key: 2,
            type: n.value,
            onLeftClick: o[1] || (o[1] = (s) => e.$emit("left-click")),
            onRightSecondaryClick: o[2] || (o[2] = (s) => e.$emit("right-secondary-click")),
            onRightPrimaryClick: o[3] || (o[3] = (s) => e.$emit("right-primary-click"))
          }, null, 8, ["type"]))
        ], 64)) : m("", !0)
      ]),
      _: 2
    }, [
      e.$slots.header && e.showHeader ? {
        name: "header",
        fn: i(() => [
          e.showBack ? (t(), l(a(P), {
            key: 0,
            size: "18",
            class: "cursor-pointer mr-2",
            onClick: o[0] || (o[0] = (s) => e.$emit("back"))
          }, {
            default: i(() => [
              u(a(z))
            ]),
            _: 1
          })) : m("", !0),
          e.showHeaderIcon ? (t(), l(L, {
            key: 1,
            size: "sm",
            color: "var(--n-dialog-icon-stroke)",
            "bg-color": "var(--n-dialog-icon-bg-color)"
          }, {
            default: i(() => [
              (t(), l(O(c[n.value])))
            ]),
            _: 1
          })) : m("", !0),
          u(a(k), {
            size: "2xl",
            weight: "semibold"
          }, {
            default: i(() => [
              f(e.$slots, "header")
            ]),
            _: 3
          })
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["auto-focus", "class", "close-on-esc", "mask-closable", "show", "style", "theme-overrides", "to", "z-index"]));
  }
});
export {
  ae as default
};
